import React from 'react';
import { GenericFormPage } from '../../components/generic';
import { useSupplierInvoicePayment, SupplierInvoicePayment } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<SupplierInvoicePayment>
      useData={useSupplierInvoicePayment}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
